import React from 'react'

import EditSectionsList from '../../../../../features/components/Forms/EditForm/EditSectionsList'

import { useDv360CampaignBudgetEditSections } from './useDv360CampaignBudgetEditSections'

const Dv360EditSections = ({ campaign, isEditDataLoading }) => {
  const { editSections, sectionsInitialOpenStates } = useDv360CampaignBudgetEditSections(campaign?.id)

  return (
    <EditSectionsList
      editSections={editSections}
      isEditDataLoading={isEditDataLoading}
      editItemData={campaign}
      sectionsInitialOpenStates={sectionsInitialOpenStates}
    />
  )
}

export default Dv360EditSections
